// src/redux/appointment/appointment.reducer.js
import { AppointmentActionTypes } from './appointment.actions';

const INITIAL_STATE = {
  appointments: [],
  loading: false,
  error: null
};

const appointmentReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AppointmentActionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload
      };
      
    case AppointmentActionTypes.SET_ERROR:
      return {
        ...state,
        error: action.payload
      };
      
    case AppointmentActionTypes.SET_APPOINTMENTS:
      return {
        ...state,
        appointments: action.payload || []
      };
      
    case AppointmentActionTypes.CREATE_APPOINTMENT:
      return {
        ...state,
        appointments: [action.payload, ...state.appointments]
      };
      
    default:
      return state;
  }
};

export default appointmentReducer;